import { useCallback } from 'react';

import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';
import { AIArtifactOptions } from 'models/AIArtifact';
import AIJob, { AIJobStatus } from 'models/AIJob';

type AIJobChannelMessage = {
  id: string;
  status: AIJobStatus;
  type: string;
  error?: string;
  config?: {
    attachmentIds?: string[];
  };
  aiJobbableId: string;
  aiArtifact?: AIArtifactOptions;
};

type UseAIJobChannelOptions = {
  aiJobId?: string;
  onMessageReceived?: (job: AIJob) => void;
};

export default function useAIJobChannel({ aiJobId, onMessageReceived }: UseAIJobChannelOptions) {
  const handleReceived = useCallback(
    (data: AIJobChannelMessage) => {
      const job = new AIJob(data);

      onMessageReceived?.(job);
    },
    [onMessageReceived]
  );

  const { isConnected } = useWebsocketSubscription<AIJobChannelMessage>({
    channel: 'AIJobChannel',
    params: { ai_job_id: aiJobId },
    onReceived: handleReceived,
    enabled: !!aiJobId,
  });

  return {
    isSubscribed: isConnected,
  };
}
